"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StripeService = void 0;
var _environment = require("../environment");
var _http = require("./http");
var _partner = require("./partner");
class StripeService {
  static async createCheckoutSession({
    partnerCode,
    priceId,
    productId,
    customPrice,
    customPriceRecurrence
  }) {
    try {
      const params = {};
      if (priceId) params.price_id = priceId;
      if (productId) params.product_id = productId;
      if (customPrice !== undefined) {
        params.price_value_in_cents = customPrice;
        if (customPriceRecurrence !== undefined) params.recurring_interval = customPriceRecurrence === 'annual' ? 'year' : 'month';
      }
      const {
        stripe_url
      } = await _http.HttpService.post('v1', `/billing/stripe/checkout_session`, [], [], JSON.stringify(params), {
        partner: partnerCode
      });
      return stripe_url;
    } catch (err) {
      console.error('[StripeService][createCheckoutSession]', err);
      throw new Error(err);
    }
  }
  static async createPortalSession({
    code: partner
  }) {
    try {
      const {
        stripe_url
      } = await _http.HttpService.post('v1', `/billing/stripe/portal_session`, [], [], null, {
        partner
      });
      return stripe_url;
    } catch (err) {
      console.error('[StripeService][createPortalSession]', err);
      throw new Error(err);
    }
  }
  static async getProducts({
    contractCodes
  }) {
    try {
      const products = await new Promise((resolve, reject) => {
        const request = new XMLHttpRequest();
        request.open('GET', `https://api.stripe.com/v1/products?active=true`, true);
        request.responseType = 'json';
        request.setRequestHeader('Authorization', `Bearer ${_environment.defaultEnvironment.stripeApiKey}`);
        request.onload = () => {
          const {
            status,
            response
          } = request;
          if (status == 200) {
            resolve(response.data.map(({
              id,
              metadata,
              description,
              features
            }) => ({
              id,
              contractCode: metadata?.contract_code && _partner.contractTemplateCodes[metadata.contract_code] || '',
              description,
              descriptionLong: metadata?.description_long || '',
              features: features.map(({
                name
              }) => name)
            })));
          } else {
            reject(response || new Error(`Error ${status}`));
          }
        };
        request.onerror = () => {
          console.error('[HTTP] Request Error');
          reject(request.response);
        };
        request.send(null);
      });
      return products.filter(({
        contractCode
      }) => contractCodes.includes(contractCode));
    } catch (err) {
      console.error('[StripeService][getProducts]', err);
      throw err;
    }
  }
  static async getPrices({
    productId
  }) {
    try {
      const prices = await new Promise((resolve, reject) => {
        const request = new XMLHttpRequest();
        request.open('GET', `https://api.stripe.com/v1/prices?active=true&product=${productId}&currency=eur`, true);
        request.responseType = 'json';
        request.setRequestHeader('Authorization', `Bearer ${_environment.defaultEnvironment.stripeApiKey}`);
        request.onload = () => {
          const {
            status,
            response
          } = request;
          if (status == 200) {
            resolve(response.data.filter(({
              metadata,
              recurring
            }) => metadata.company_workforce_count_limit && recurring).map(({
              id,
              metadata,
              recurring,
              unit_amount
            }) => ({
              id,
              companyMaxSize: parseInt(metadata.company_workforce_count_limit || ''),
              periodType: recurring?.interval || 'month',
              price: unit_amount / 100
            })).filter(({
              companyMaxSize
            }) => !Number.isNaN(companyMaxSize)));
          } else {
            reject(response || new Error(`Error ${status}`));
          }
        };
        request.onerror = () => {
          console.error('[HTTP] Request Error');
          reject(request.response);
        };
        request.send(null);
      });
      return prices.filter(({
        companyMaxSize,
        periodType
      }) => !isNaN(companyMaxSize) && companyMaxSize >= 0 && ['month', 'year'].includes(periodType));
    } catch (err) {
      console.error('[StripeService][getPrices]', err);
      throw err;
    }
  }
}
exports.StripeService = StripeService;